/* FileName.js */

"use strict";
const _ = require("lodash");
const moment = require("moment-timezone");

function fileName(options = {}) {
    const separator = options.separator || "_";
    const solution = (options.solution || "gluware") + separator;
    const general = (options.general || "general") + separator;
    const specific = (options.specific || "download").replace(/ /g, "_") + separator;
    const suffix = options.suffix ? "." + options.suffix : "";
    const TZ = moment.tz.guess();
    let rawDate = options.date;
    if (_.isDate(rawDate)) {
        if (_.isNaN(rawDate.getTime())) {
            rawDate = new Date();
        }
    } else if (rawDate && !_.isNaN(new Date(rawDate).getTime())) {
        rawDate = new Date(rawDate);
    } else {
        rawDate = new Date();
    }
    const date = moment.tz(rawDate.toISOString(), TZ).format("YYYYMMDD_HHmmss_z");

    return `${solution}${general}${specific}${date}${suffix}`;
}

module.exports = fileName;
